import { RESET_CBGU, GET_CALCULATE_CBGU_SUCCESS } from '../constants/constants';

const defaultStore = {
  cbgu: '',
  cbgucalories: '',
};

export default (state = defaultStore, action) => {
  switch (action.type) {
    case GET_CALCULATE_CBGU_SUCCESS:
      return {
        ...state,
        cbgu: action.data,
        cbgucalories: action.data[0].calories,
      };
    case RESET_CBGU:
      return {
        ...state,
        cbgu: { 0: { calories: 0 }, carbohydrates: 0, fats: 0, proteins: 0 },
        cbgucalories: 0,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/calculateCbgu.js